import { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, TextField,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Diálogo para bloquear un candidato (lista negra de la org). Motivo opcional.
 * onConfirm recibe el motivo (string).
 */
const AtsBlockDialog = ({ open, onClose, candidateName, onConfirm }) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t('ats.detail.blockTitle')}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {t('ats.detail.blockConfirm', { name: candidateName })}
        </Typography>
        <TextField
          fullWidth
          multiline
          minRows={3}
          label={t('ats.detail.blockReason')}
          placeholder={t('ats.detail.blockReasonPlaceholder')}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">{t('cancel')}</Button>
        <Button onClick={() => onConfirm && onConfirm(reason)} color="error" variant="contained">
          {t('ats.detail.blockConfirmButton')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AtsBlockDialog;
